
import orderUtil from '../../Utils/orderUtil.js';
const Css = {
  SlideBall(imgBottom){
    return {
      position: "absolute",
      width: (orderUtil.controlBoxWidth - 12) + "px",
      height: "36px",
      bottom:  imgBottom + "px",
      left: "12px",
      transition: "all 0.02s linear",
      cursor: "pointer",
    }
  },
  imgBall(editorMode){
    let obj = {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      marginLeft: ((orderUtil.controlBoxWidth - 12 - 36)/2) + "px",
      cursor: "pointer",
      position: "absolute",
      zIndex:4,
      userSelect: "none"
    };
    let grayObj = {};
    if(editorMode.edMode !== 1){
      const str = "grayscale(100%)";
      grayObj = {
        WebkitFilter: str,
        MozFilter: str,
        msFilter: str,
        OFilter: str,
        filter: str,
        cursor: "default",
      }
    }
    return Object.assign({}, obj, grayObj);
  },
  splitLine:{
    position: "absolute",
    top: "18px",
    width: (orderUtil.controlBoxWidth - 12) + "px",
    height: "1px",
    backgroundColor: "#fff",
    opacity: 0.3,
    filter: "alpha(opacity=3)",
    MozOpacity: 0.3,
    zIndex:4
  }
};

export default Css;